/**
 * An admin account is blocked only when the backend says so explicitly. A missing flag (older
 * backend, or a row that never carried it) reads as active so nobody is shown as blocked by accident.
 */
export const isAdminBlocked = isEnabled => isEnabled === false;
export const adminStatusLabelKey = isEnabled => isAdminBlocked(isEnabled) ? 'admin_page.status_blocked' : 'admin_page.status_active';
export const adminStatusChipVariant = isEnabled => isAdminBlocked(isEnabled) ? 'critical' : 'success';